import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// mui icons
import CloseIcon from "@mui/icons-material/Close";

// mui components
import { Box, Divider, Stack, Tab, Tabs } from "@mui/material";

// custom components
import TabPanel from "../../../tab-panel";
import CustomTable from "../../../custom-table";
import SecondaryButton from "../../../buttons/secondary-button";
import Heading3 from "../../../typography/heading-03";
import Heading5 from "../../../typography/heading-05";
import Heading6 from "../../../typography/heading-06";
import Body2 from "../../../typography/body-02";

// redux slices
import { selectUserDetails } from "../../../../features/auth/authSlice";
import { selectImpersonatedUser } from "../../../../features/admin/impersonated-user/impersonatedUserSlice";

// helper utils
import { formatCurrency } from "../../../../utils/format-currency";
import { selectedUser } from "../../../../utils/common-helpers";

// custom styles
import styles from "./index.module.scss";

const AdjusmentProductDrawer = ({ handleCloseDrawer, drawerData }) => {
	const userDetails = useSelector(selectUserDetails);
	const impersonatedUser = useSelector(selectImpersonatedUser);

	const currentUser = selectedUser(userDetails, impersonatedUser);

	console.log("40 current user:", currentUser);

	const productAdjustmentsColumn = [
		{
			id: "description",
			label: "Description of Loan Level Price or Rate Adjuster",
			minWidth: 310,
		},
		// { id: "rate", label: "Rate", minWidth: 175, align: "right" },
		{ id: "price", label: "Price", minWidth: 175, align: "right" },
	];

	const productAdjustmentsPriceHiddenColumn = [
		{
			id: "description",
			label: "Description of Loan Level Price or Rate Adjuster",
			minWidth: 310,
		},
		{ id: "rate", label: "Rate", minWidth: 175, align: "right" },
	];

	const productPaymentsColumn = [
		{ id: "item", label: "Item", minWidth: 310 },
		{ id: "payment", label: "Payment", minWidth: 175, align: "right" },
	];

	const [paymentsData, setPaymentsData] = useState([]);
	const [prepaidInterest, setPrepaidInterest] = useState(0);

	const [tabValue, setTabValue] = useState(0);

	const handleChangeTab = (event, newValue) => {
		setTabValue(newValue);
	};

	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}

	console.log(
		"90 adjustment data:",
		drawerData?.productDetails
	);

	console.log("30 drawer data:", drawerData);

	const adjustmentRowData =
		[
			...drawerData?.productDetails?.data?.adjustments,
			{
				reason: "Total Adjustments",
				rate: drawerData?.productDetails?.data?.totalRateAdjustment,
				adjustor: drawerData?.productDetails?.data?.totalPriceAdjustment,
			},
			{
				reason: "Final",
				rate: drawerData?.rowData?.rate,
				adjustor: drawerData?.rowData?.price,
			},
		] || [];

	console.log("30 adjustment row data:", adjustmentRowData);

	let isPriceHidden = false;

	if (["CB", "WHS"].includes(currentUser?.loan_channel)) {
		isPriceHidden = ["manager", "AM", "executive", "AE"].some((role) =>
			currentUser?.user_roles?.includes(role)
		);
	} else if (["NDC", "CORR"].includes(currentUser?.loan_channel)) {
		isPriceHidden = !(
			currentUser?.user_roles === "admin" ||
			currentUser?.access_level === "TPO Secondary" ||
			currentUser?.access_level === "broker admin"
		);
	}

	console.log("150 is pricer hidden:", isPriceHidden);

	return (
		<Stack direction="column" className={styles.stackContainer}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				className={styles.drawerHeaderContainer}
			>
				<Heading3
					text="Loan product details and summary"
					extraClass={styles.headerText}
					fontType="semibold"
				/>
				<SecondaryButton
					startIcon={<CloseIcon />}
					text="Close"
					onClick={handleCloseDrawer}
				/>
			</Stack>
			<Stack direction="column" className={styles.drawerBodyContainer}>
				<Heading5
					text={drawerData?.productDetails?.productName}
					extraClass={styles.greenText}
					fontType="semibold"
				/>

				<Tabs
					value={tabValue}
					// onChange={handleChangeTab}
					aria-label="eligible product tabs"
					TabIndicatorProps={{
						style: {
							backgroundColor: "#49787F",
						},
					}}
				>
					
					<Tab
						className={styles.tabBtnContainer}
						label={
							<Stack direction="row" className={styles.tabLabelContainer}>
								<Heading6
									text="Adjustments"
									fontType="semibold"
									extraClass={
										tabValue === 0 ? styles.activeTabText : styles.tabText
									}
								/>
							</Stack>
						}
						{...a11yProps(0)}
					/>

				</Tabs>


				{/* adjustments tab */}
				<TabPanel
					index={0}
					value={tabValue}
					className={tabValue === 0 ? styles.tabPanelContainer : ""}
				>
					<CustomTable
						squaredBorder={true}
						tableType="eligible-product-adjustments"
						columnData={
							isPriceHidden
								? productAdjustmentsPriceHiddenColumn
								: productAdjustmentsColumn
						}
						rowData={adjustmentRowData || []}
						extraData={drawerData?.productDetails || []}
						hideAdjustmentPriceColumn={isPriceHidden}
					/>
				</TabPanel>
			</Stack>
		</Stack>
	);
};

export default AdjusmentProductDrawer;
